import { render } from "./ViewPremiumSummary.vue?vue&type=template&id=16e52b84&ts=true"
import script from "./ViewPremiumSummary.vue?vue&type=script&lang=ts"
export * from "./ViewPremiumSummary.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ViewPremiumSummary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16e52b84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16e52b84', __exports__)) {
    api.reload('16e52b84', __exports__)
  }
  
  module.hot.accept("./ViewPremiumSummary.vue?vue&type=template&id=16e52b84&ts=true", () => {
    api.rerender('16e52b84', render)
  })

}


export default __exports__